export default __webpack_public_path__ + "static/Transcript_Form-67827c5806688fc02e700fe613360e33.pdf";